module.exports = __webpack_public_path__ + "trunking_name.svg?b6bab29878fa46db9838253f0852cdd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/trunking_name.svg
// module id = 24
// module chunks = 0